import tracking from './tracking';

export default tracking;
